import chalk from "chalk";

import { isBrowser } from "../common/utils";

// 原基于 universal-logger 实现，但发现某些场景下重复log。简单处理为 console 输出

const LOG_LEVEL_MAP = { trace: 0, debug: 1, info: 2, warn: 3, error: 4 };

let ENV_LOG_LEVEL = "info";

let SERVER_LOG_DEPTH = 2;

/*
 * 定义见 index.d.ts
 * 待重构为独立组件
 */
const defaultLogger = wrapMyLogger("", "debug");
export default defaultLogger;

function wrapMyLogger(namespace, defaultLevel) {
  if (!(defaultLevel in LOG_LEVEL_MAP)) {
    throw new Error("not supports level: " + defaultLevel);
  }
  const myLogger = Object.create({});

  myLogger.setLogOptions = function ({ env, serverLogDepth }) {
    switch (env) {
      case "prod":
        ENV_LOG_LEVEL = "info";
        break;
      case "test":
        ENV_LOG_LEVEL = "debug";
        break;
      case "local":
        ENV_LOG_LEVEL = "trace";
        break;
      default:
        ENV_LOG_LEVEL = "info";
    }
    SERVER_LOG_DEPTH = serverLogDepth || 2;
  };

  // assign methods
  const methods = Object.keys(LOG_LEVEL_MAP);
  methods.forEach((m) => {
    Object.defineProperty(myLogger, m, {
      writable: false,
      value: function () {
        if (LOG_LEVEL_MAP[m] >= LOG_LEVEL_MAP[ENV_LOG_LEVEL]) {
          doLog(m, namespace, arguments);
        }
      },
    });
  });
  Object.defineProperty(myLogger, "log", {
    writable: false,
    value: function () {
      if (LOG_LEVEL_MAP[defaultLevel] >= LOG_LEVEL_MAP[ENV_LOG_LEVEL]) {
        doLog(defaultLevel, namespace, arguments);
      }
    },
  });

  // extends getNamespacedLogger
  Object.defineProperty(myLogger, "getNamespacedLogger", {
    writable: false,
    value: createNamespaceLogger,
  });

  return myLogger;
}

function doLog(logMethod, namespace, logArguments) {
  let logData = Array.prototype.slice.call(logArguments);
  if (!isBrowser) {
    // server 时额外处理字符串转换，防止输出对象过大
    const util = require("util");
    const messages = logData.map((x) =>
      typeof x !== "object"
        ? x
        : util.inspect(x, { depth: SERVER_LOG_DEPTH, compact: true }).replace(/\s*\n\s*/g, " ")
    );
    let levelColor;
    if (logMethod) {
      switch (logMethod) {
        case "error":
          levelColor = "red";
          break;
        case "warn":
          levelColor = "yellow";
          break;
        case "info":
          levelColor = "green";
          break;
        default:
          levelColor = "gray";
          break;
      }
    }
    // eslint-disable-next-line no-console
    console[logMethod](
      [
        chalk[levelColor](logMethod.toUpperCase()),
        namespace,
        chalk.gray(new Date().toISOString()),
      ].join(" "),
      messages.join(" | ")
    );
  } else {
    // eslint-disable-next-line no-console
    console[logMethod]([namespace, new Date().toISOString()].join(" "), ...logData);
  }

  // TODO 展示 log 处的堆栈
}

function createNamespaceLogger(namespace, defaultLevel = "debug") {
  // 不能在此依赖模块变量缓存
  // 先每次创建，寻找 nodejs 侧跨请求的方案
  return wrapMyLogger(namespace, defaultLevel);
}
